module.exports = __webpack_public_path__ + "img/NKU.94e9d92c.png";